import React from 'react';
import { Link } from 'react-router-dom';
type Variant = 'primary' | 'secondary' | 'light' | 'outlineLight';
type ButtonLinkProps = {
  to: string;
  variant?: Variant;
  children: React.ReactNode;
  className?: string;
};
const variants: Record<Variant, string> = {
  primary: 'bg-navy text-white hover:bg-navy-700',
  light: 'bg-white text-navy hover:bg-ivory',
  secondary: 'border border-navy text-navy hover:bg-navy hover:text-white',
  outlineLight: 'border border-white/40 text-white hover:border-white hover:bg-white/10'
};
export function ButtonLink({
  to,
  variant = 'primary',
  children,
  className = ''
}: ButtonLinkProps) {
  return <Link to={to} className={`inline-flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-sm px-6 text-sm font-semibold tracking-wide transition-colors duration-150 ease-crisp focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold ${variants[variant]} ${className}`} data-id="element-14" data-mp="3sulo3mjqwfsg">
      {children}
    </Link>;
}